import { render, staticRenderFns } from "./AccountAdminAddUser.vue?vue&type=template&id=0cb879e8&"
import script from "./AccountAdminAddUser.vue?vue&type=script&lang=js&"
export * from "./AccountAdminAddUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports